import React, { ReactElement } from 'react';
import { Flex, Text, Tag } from '@chakra-ui/react';

interface TagListSectionProps {
  sectionName: string;
  items: string[];
}

function TagListSection({ sectionName, items = [] }: TagListSectionProps): ReactElement | null {
  const uniqueItems = [...new Set(items)];
  if (!uniqueItems.length) return null;

  return (
    <Flex direction="column" gridGap="2">
      <Text
        fontSize="xs"
        textTransform="capitalize"
        color="#000"
        fontWeight="400"
        lineHeight="16px"
        fontFamily="Inter"
        fontStyle="normal"
      >
        {sectionName}
      </Text>
      <Flex wrap="wrap" gridRowGap="2" gridColumnGap="2">
        {uniqueItems?.map(item => (
          <Tag
            key={item}
            py="1"
            borderWidth={1}
            borderRadius="xl"
            bg="white.50"
            borderColor="gray.200"
            fontSize="xs"
            fontWeight="300"
          >
            {item}
          </Tag>
        ))}
      </Flex>
    </Flex>
  );
}

export default TagListSection;
